import {createActionWithoutPayload, createActionWithPayload} from "./utils";
import {ContactMarqueCollection} from "../types";


export const [getContact, isGetContactAction ] = createActionWithoutPayload('GET_CONTACT');
export const [contactError, isContactError ] = createActionWithoutPayload('CONTACT_ERROR');
export const [getContactSuccess, isGetContactSuccess ] = createActionWithPayload<ContactMarqueCollection[]>('GET_CONTACT_SUCCESS');
export const [setContacts, isSetContactAction]= createActionWithPayload<ContactMarqueCollection[]>('SET_CONTACT');
